import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import Dashboard from '../pages/Dashboard';
import Settings from '../pages/Settings/Settings';
import EcommerceSetup from '../pages/EcommerceSetup';
import Insights from '../pages/Insights';
// import BillingUsage from '../pages/BillingUsage';
import Billing from '../pages/Billing';
import BasicSetup from '../pages/BasicSetup';
// import KnowledgeBase from '../pages/KnowledgeBase/index';
import Widget from '../pages/Widget/index.jsx';
import Conversation from '../pages/Conversations/index';
import Voices from '../pages/Voices';
import TestZone from '../pages/TestZone';
import EmailSetup from '../pages/EmailSetup/index';
import Integration from '../pages/Integration/Integration';
import TokenLogin from '../pages/TokenLogin';
import Agent from '../pages/KnowledgeBase/Agent';
import CallAgent from '../pages/CallAgent/index';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsAndConditions from '../pages/TermsAndConditions';
import Packages from '../pages/Settings/Packages';

function PrivateRoute({ children }) {
  const isLoggedIn = !!localStorage.getItem('token');
  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const isLoggedIn = !!localStorage.getItem('token');
  return isLoggedIn ? <Navigate to="/dashboard" replace /> : children;
}

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        {/* <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} /> */}
        <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
        <Route path="/token-login" element={<TokenLogin />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/settings/packages" element={<PrivateRoute><Packages /></PrivateRoute>} />
        {/* <Route path="/ecommerce-setup" element={<PrivateRoute><EcommerceSetup /></PrivateRoute>} /> */}
        {/* <Route path="/email-setup" element={<PrivateRoute><EmailSetup /></PrivateRoute>} /> */}
        {/* <Route path="/billing-usage" element={<PrivateRoute><BillingUsage /></PrivateRoute>} /> */}
        <Route path="/billing-usage" element={<PrivateRoute><Billing /></PrivateRoute>} />
        <Route path="/payment-method" element={<PrivateRoute><Billing /></PrivateRoute>} />
        <Route path="/billing-history" element={<PrivateRoute><Billing /></PrivateRoute>} />
        <Route path="/basic-setup" element={<PrivateRoute><BasicSetup /></PrivateRoute>} />
        {/* <Route path="/knowledge-base" element={<PrivateRoute><Agent /></PrivateRoute>} /> */}
        <Route path="/agent" element={<PrivateRoute><Agent /></PrivateRoute>} />
        {/* <Route path="/call-agent" element={<PrivateRoute><CallAgent /></PrivateRoute>} /> */}
        <Route path="/widget" element={<PrivateRoute><Widget /></PrivateRoute>} />
        <Route path="/conversations" element={<PrivateRoute><Conversation /></PrivateRoute>} />
        <Route path="/voices" element={<PrivateRoute><Voices /></PrivateRoute>} />
        <Route path="/test-zone" element={<PrivateRoute><TestZone /></PrivateRoute>} />
        <Route path="/integration" element={<PrivateRoute><Integration /></PrivateRoute>} />
        <Route path="/insights" element={<PrivateRoute><Insights /></PrivateRoute>} />
        <Route path="/" element={<TokenLogin />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default AppRoutes;
